module.exports = __webpack_public_path__ + "img/daijinquan_bg1.9adc96a9.png";